// extracted by mini-css-extract-plugin
export var container = "_6w-0";
export var fallback = "_6w-5";
export var fallbackIcon = "_6w-6";
export var hidden = "_6w-2";
export var image = "_6w-3";
export var loaded = "_6w-4";
export var placeholder = "_6w-1";